export default import.meta.ROLLUP_FILE_URL_3L5oVUZg;